module.exports = __webpack_public_path__ + "images/ds-lda-instructor-shashank-kalanithi-1-mobile.webp";